<template>
    <div class="rp-helpdesk-conversation-message-file">
        <img @click="showFullImage"
        class="image-preview"
        v-if="isItImage && !loadingImagePreview && imageUrl" :src="imageUrl" />
        <a v-else
            @click="handleFileClick"
            href="#"
            class="rp-helpdesk-conversation-message-file-box">
            <span class="file-icon">
                <AttachmentIcon />
            </span>
            <span class="file-name">
                {{ fileName }}
            </span>
            <span
                v-if="isLoading"
                class="download-loader">
                <i class="el-icon-loading"></i>
            </span>
        </a>
        
    </div>
</template>

<script>
import Message from '../../models/Message'
import AttachmentIcon from './AttachmentIcon'
import MessengerEventBus from '../../MessengerEventBus'
export default {

    components: {
        AttachmentIcon
    },
    
    props: {

        message: {
            type: Object,
            required: true
        }

    },

    data() {
        return {
            isLoading: false,
            loadingImagePreview: false,
            imageUrl: '',
        }
    },

    computed: {

        fileName() {
            const { mediaValue } = this.message;
            if (mediaValue instanceof File) {
                return mediaValue.name;
            } else if (typeof mediaValue === 'string') {
                const [ParentBucket, Bucket, Name] = mediaValue.split('/');
                return Name;
            }
            return 'File';
        },
        fileExtension() {
            return this.fileName.split('.').pop();
        },
        isItImage() {
            return ['png', 'jpg', 'gif', 'jpeg'].includes(this.fileExtension)
        },
        

    },

    async mounted() {
        if(this.$root.imagesCache[this.fileName]) {
            this.imageUrl = this.$root.imagesCache[this.fileName]
        } else {
            this.imageUrl =  await this.getFileObjectUrl();
            this.addImageToCache();
        }
        
    },

    methods: {
        addImageToCache() {
            if(this.imageUrl) {
                try {
                    let images = Object.keys(this.$root.imagesCache);
                    if(images.length>100) {
                        delete this.$root.imagesCache[images[0]]
                    }
                    this.$root.imagesCache[this.fileName] = this.imageUrl;
                } catch(e) {
                    console.log(e)
                }
            }
        },
        showFullImage() {
            MessengerEventBus.$emit('SHOW_FULL_IMAGE', { imageUrl: this.imageUrl })
        },
        async getFileObjectUrl() {
            try {
                if(!this.isItImage) return '';
                this.loadingImagePreview = true;
                const { mediaValue } = this.message;
                let url = '';
                if (mediaValue instanceof File) { 
                    url = window.URL.createObjectURL(mediaValue);
                } else {
                    const response = await Message.fileDownload(this.message.mediaValue);
                    url = window.URL.createObjectURL(new Blob([response.data]));
                }
                this.loadingImagePreview = false;
                return url;
            } catch(e) {
                console.log(e)
                this.loadingImagePreview = false;
                return '';
            }
        },
        async handleFileClick() {
            if (this.isLoading || this.message.isDirty) return

            this.isLoading = true;
            
            const response = await Message.fileDownload(this.message.mediaValue);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.fileName);
            document.body.appendChild(link);
            link.click();

            this.isLoading = false;
        }



    }

}
</script>

<style lang="scss">

.rp-helpdesk-conversation-message-file {
    color: $blackColor;
    .image-preview {
        cursor: zoom-in;
        max-height: 200px;
        max-width: 200px;
        width: fit-content;
    }
    
    &:first-child {
        padding-top: 0;
    }

    &:last-child {
        padding-bottom: 0;
    }

    &.from-operator {
        .rp-helpdesk-conversation-message-file-box {
            background: #f6f6f6;
        }
    }

    &.from-customer {
        .rp-helpdesk-conversation-message-file-box {
            background: #ebebeb;
        }
    }
}

.rp-helpdesk-conversation-message-file-box {
	padding: 14px;
    border-radius: 5px;
    position: relative;
    display: inline-block;
    width: auto;
	max-width: 75%;
	font-size: 14px;
    font-weight: 400;
    min-width: 80px;
    word-break: break-word;

    .file-icon,
    .file-name,
    .download-loader {
        display: inline-block;
        vertical-align: middle;
    }

    .file-icon {
        @include square(15px);
        margin-right: 8px;
    }

    .file-name {
        cursor: pointer;
        text-decoration: underline;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 90%;
    }

    .download-loader {
       margin-left: 8px;
    }
}

</style>